import { connect } from "react-redux";
import { TitleLoader } from "../Loader";
import "./styles.css";
import { Button } from "../Button";
import icons from "../../constants/icons";

const Header = (props) => {
  return (
    <>
      {props.back && (
        <div style={{ marginBottom: "1rem" }}>
          <Button
            icon={icons.back}
            className="btn-sm btn-default"
            text="Back"
            onPress={props.goBack}
          />
        </div>
      )}
      <div className="dashboard-header-container">
        <div className="left-container">
          {props.isLoading ? (
            <TitleLoader />
          ) : (
            <>
              <h2
                className={`text-capitalized text-bold ${props.titleClassName}`}
              >
                {props.name || props.title}
              </h2>
              {props.description && <p>{props.description} </p>}
            </>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Header);
